import { Propuesta, EstadoPropuesta } from './../../../interfaces/propuesta';
import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { IncidenciaService } from '../../../providers/incidencia.service';
import { Sort, PageEvent, MatTableDataSource, MatSort, MatSelect, MatExpansionPanel, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { Incidencia } from '../../../interfaces/incidencia';
import { Entidad, TipoEntidad } from '../../../interfaces/entidad';
import { TipoIncidencia } from '../../../interfaces/tipo-incidencia';
import { Cotizacion } from '../../../interfaces/cotizacion';
import { TipoIncidenciaService } from '../../../providers/tipo-incidencia.service';
import { Usuario, TipoUsuario } from '../../../interfaces/usuario';
import { Telefono } from '../../../components/telefono/telefono.component';
import { UsuarioService } from '../../../providers/usuario.service';
import { VolverService } from '../../../providers/volver.service';
import * as moment from 'moment';
import { ZerosPipe } from '../../../pipes/transforms/zeros.pipe';
import { FormatDatePipe } from '../../../pipes/transforms/format-date.pipe';
import { BooleanTraductorPipe } from '../../../pipes/transforms/boolean-traductor.pipe';
import { Contacto } from '../../../interfaces/contacto';

@Component({
  selector: 'app-ver-incidencias',
  templateUrl: './ver-incidencias.component.html',
  styleUrls: ['./ver-incidencias.component.scss']
})
export class VerIncidenciasComponent implements OnInit, OnDestroy {
  title = "Incidencias";
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaIncidenciasColumnas = ['fechaAlta', 'entidad', 'contacto','created_by', 'propuesta', 'cotizacion', 'tipo', 'observacion'];
  incidenciasDataSource = new MatTableDataSource();
  @ViewChild(MatSort) matSort: MatSort;
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  getIncidenciasSuscripcion = new Subscription();
  incidenciasCount: number = 0;
  tiposIncidencia: TipoIncidencia[] = [];
  cargandoTiposIncidencia: boolean = false;
  usuarios: Usuario[] = [];
  cargandoUsuarios: boolean = false;
  // filtros que se aplican según el lugar donde se muestran las incidencias
  @Input() filtrosExternos: any = {};
  filtros: any = {
    generico: '',
    tipoIncidencia: '',
    numero: '',
    created_by: '',
    propuesta:'',
    entidad: '',
    contacto:''
  };
  @ViewChild('filtroCreadaPor') set filtroCreadaPor(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.IdUsuario == b.IdUsuario; };
  };
  @ViewChild('filtroTipoIncidencia') set filtroTipoIncidencia(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.id == b.id; };
  };
  // si tiene algún elemento, es que se está cargando algo para los filtros
  cargandoFiltros = [];
  tieneFiltrosOrdenPaginado: boolean = false;
  // true si hay almenos un filtro activo
  panelConFiltroActivo = false;
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 0);
    }
  };
  descargandolistado: boolean = false;

  constructor(
    private incidenciaService: IncidenciaService,
    private tipoIncidenciaService: TipoIncidenciaService,
    private usuarioService: UsuarioService,
    private volverSv: VolverService,
    private snackBar: MatSnackBar,
    private zerosPipe: ZerosPipe,
    private datePipe: FormatDatePipe,
    private booleanPipe: BooleanTraductorPipe
  ) { }

  ngOnInit() {
    this.traerTiposIncidencia();
    this.traerUsuarios();

    // set valores iniciales
    if (this.volverSv.usaronBotonVolver()) {
      this.restaurarPageState();
    } else {
      this.reiniciarPageState();
    }
  }

  /**
   * limpia las variables de page state
   * y luego restaura el estado al estado inicial
   */
  reiniciarPageState() {
    this.limpiarPageState();
    this.restaurarPageState();
  }

  /**
   * olvidar el estado de la página
   */
  limpiarPageState() {
    // filtros
    localStorage.setItem('ver_incidencias_filtros', null);
    // paginado
    localStorage.setItem('ver_incidencias_paginado', null);
    // sort
    localStorage.setItem('ver_incidencias_sort', null);
  }

  /**
   * recuerda el estado de la página por si vuelven a ingresar
   * y hay que mostrarla tal cual como estaba
   */
  recordarPageState() {
    // filtros
    localStorage.setItem('ver_incidencias_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_incidencias_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_incidencias_sort', JSON.stringify(this.sort));
  }

  /**
   * restaudar la página al estado en que estaba
   */
  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_incidencias_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_incidencias_paginado'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_incidencias_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_incidencias_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('fechaAlta', 'desc');
    }
    this.actualizarTabla();
  }

  /**
   * revisa las variables de page state para ver
   * si hay almenos una aplicada ya sea filtrado, paginado u ordenamiento
   */
  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fechaAlta' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }

    return this.tieneFiltrosOrdenPaginado;
  }

  /**
   * Para arreglar un bug de angular usamos esta funcion para ordenar
   */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_incidencias_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  actualizarTabla(): void {    
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo de busqueda
        this.cargando = true;
      }, 750);

      if (this.getIncidenciasSuscripcion && !this.getIncidenciasSuscripcion.closed) {
        this.getIncidenciasSuscripcion.unsubscribe();
      }

      this.recordarPageState();
      this.checkPageState();
      this.getIncidenciasSuscripcion = this.incidenciaService
        .getIncidencias(
          {
            page: this.page.pageIndex,
            pageSize: this.page.pageSize
          },
          {
            sort: this.sort.active,
            order: this.sort.direction
          },
          Object.assign(this.filtrosExternos, this.filtros) // filtros del componente mas los filtros según donde se muestra el componente
        )
        .subscribe( // suscribimos una nueva busqueda
          respuesta => {
            console.log('incidencias', respuesta);
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.incidenciasCount = respuesta.data.total;
              }

              var incidencias: Incidencia[] = []; // array de datos obtenidos
              if (respuesta.data.incidencias) {
                respuesta.data.incidencias.forEach(incidencia => {
                  console.log('incidencia', incidencia);
                  incidencias.push(<Incidencia>{
                    IdIncidencia: incidencia.idIncidencia,
                    entidad: <Entidad>{
                      IdEntidad: incidencia.entidad.idEntidad,
                      razonSocial: incidencia.entidad.razonSocial,
                      tipoEntidad: <TipoEntidad>{
                        IdTipo: incidencia.entidad.tipo.IdTipo,
                        descripcion: incidencia.entidad.tipo.TipoDescripcion
                      }
                    },
                    contacto: incidencia.contacto.nombre,
                    cotizacion: <Cotizacion>{
                      IdCotizacion: incidencia.cotizacion.IdCotizacion,
                      numero: incidencia.cotizacion.numero
                    },
                    tipo: <TipoIncidencia>{
                      id: incidencia.tipo.id,
                      descripcion: incidencia.tipo.desc
                    },
                    propuesta: <Propuesta>{

                    },
                    PropuestaNombre: incidencia.propuesta.nombre,
                    observacion: incidencia.observacion,
                    fechaAlta: incidencia.fechaAlta,
                    created_by: incidencia.created_by,
                  });
                });
              }

              this.incidenciasDataSource.data = incidencias;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  traerTiposIncidencia(): void {
    this.tiposIncidencia = [];
    this.cargandoTiposIncidencia = true;
    this.cargandoFiltros.push(true);
    this.tipoIncidenciaService.getTiposIncidencia(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: '',
        verTodos: true
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.tiposIncidencia) {
          respuesta.data.tiposIncidencia.forEach(tipoIncidencia => {
            this.tiposIncidencia.push(<TipoIncidencia>{
              id: tipoIncidencia.IdTipoIncidencia,
              descripcion: tipoIncidencia.TipoIncidenciaDesc
            });
          });
        }
      },
      () => {
        this.cargandoTiposIncidencia = false;
        this.cargandoFiltros.pop();
      },
      () => {
        this.cargandoTiposIncidencia = false;
        this.cargandoFiltros.pop();
      }
    );
  }

  traerUsuarios(): void {
    this.cargandoUsuarios = true
    this.usuarios = <Usuario[]>[];
    this.cargandoFiltros.push(true);
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach(usuario => {
            this.usuarios.push(
              new Usuario(
                usuario.id,
                usuario.usuario,
                usuario.email,
                <TipoUsuario>{
                  id: usuario.tipoUsuario.id,
                  descripcion: usuario.tipoUsuario.descripcion
                },
                null,
                usuario.nombre,
                usuario.apellido,
                new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                +usuario.estado,
                usuario.puesto,
                !!+usuario.editable,
                !!+usuario.eliminable
              )
            );
          });
        }

        this.cargandoUsuarios = false;
        this.cargandoFiltros.pop();
      },
      () => {
        this.cargandoUsuarios = false;
        this.cargandoFiltros.pop();
      }
    );
  }

  descargarListado() {
    this.descargandolistado = true;
    this.incidenciaService.getIncidencias(
      {
        page: 0,
        pageSize: this.incidenciasCount
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtrosExternos, this.filtros)
    ).subscribe(
      respuesta => {
        console.log('incidencias', respuesta);
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.incidencias) {
          const titulos = [
            "Fecha de alta",
            "Estado",
            "Creada por",
            "Prospecto/Cliente",
            "Razón social",
            "Tipo de incidencia",
            "Número cotización"
          ].join(';') + "\r\n";

          const datos = respuesta.data.incidencias.map((a: any) => {
            return [
              this.datePipe.transform(a.fechaAlta, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm:ss"),
              a.created_by,
              a.entidad.tipo.TipoDescripcion,
              a.entidad.razonSocial,
              a.tipo.desc,
              a.cotizacion.IdCotizacion ? a.cotizacion.numero : ''
            ].join(';');
          }).join("\r\n");

          const csvConfig = "data:text/csv;charset=utf-8,%EF%BB%BF";
          let csvContent = titulos + datos;
          let downloadLink = document.createElement("a");
          downloadLink.href = csvConfig + encodeURI(csvContent);
          downloadLink.download = this.title + "_" + moment().format("YYYYMMDD_HHmmss") + ".csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } else {
          this.fallaDescargarListado();
        }
      },
      (err) => {
        this.descargandolistado = false;
        this.fallaDescargarListado();
      },
      () => {
        this.descargandolistado = false;
      }
    );
  }

  fallaDescargarListado() {
    this.snackBar.open('Lo sentimos, no se pudo descargar el listado', 'OK', { duration: 4750 });
  }

  ngOnDestroy() {
    if (this.getIncidenciasSuscripcion && !this.getIncidenciasSuscripcion.closed) {
      this.getIncidenciasSuscripcion.unsubscribe();
    }
  }
}
